import { keyframes } from '@emotion/react';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px) scale(0.95); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50%      { transform: scale(1.05); }
`;

export const mainWrapperStyles = {
  height: 'auto',
};

export const iconStyles = {
  animation: `${pulse} 2s ease-in-out infinite`,
  fontSize: 48,
};

export const cancelButtonProps = {
  sx: { display: 'none' },
};

export const styles = (theme) => ({
  contentBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 24px 24px',
    animation: `${fadeIn} 0.4s ease-out`,
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    color: theme.palette.navy,
    marginBottom: 12,
    textAlign: 'center',
  },
  body: {
    fontSize: 16,
    color: 'var(--grey-110)',
    lineHeight: 1.5,
    maxWidth: 340,
    margin: '0 auto',
    textAlign: 'center',
  },
});

export default styles;
